import objectEntries from "../polyfills/objectEntries.mjs";
export default function toObjMap(obj) {
  /* eslint-enable no-redeclare */
  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  var map = Object.create(null);

  for (var _i2 = 0, _objectEntries2 = objectEntries(obj); _i2 < _objectEntries2.length; _i2++) {
    var _ref2 = _objectEntries2[_i2];
    var key = _ref2[0];
    var value = _ref2[1];
    map[key] = value;
  }

  return map;
}



//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/toObjMap.mjs
// module id = 686
// module chunks = 4